
export default {
  name: 'greetTitle'
}
